import React from 'react';
import { DateTime } from 'luxon';

import '../styles/ArticleComment.css';
import { string } from 'prop-types';

const ArticleComment = ({ name, email, message, createdAt }) => {
    return (<div
        className={'article-comment--container'}>
        <p
            className={'article-comment--info'}>
            <span><strong>{name}</strong></span>
            <span
                className={'article-comment--date'}> - {DateTime.fromISO(createdAt).toLocaleString(DateTime.DATETIME_MED)}</span>
        </p>
        <p
            className={'article-comment--message'}>
            {message}
        </p>
    </div>);
};

ArticleComment.propTypes = {
    name: string,
    email: string,
    message: string,
    createdAt: string,
};

export default ArticleComment;